import { render, staticRenderFns } from "./traceManage.vue?vue&type=template&id=895484ae&scoped=true&"
import script from "./traceManage.vue?vue&type=script&lang=js&"
export * from "./traceManage.vue?vue&type=script&lang=js&"
import style0 from "./traceManage.vue?vue&type=style&index=0&id=895484ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895484ae",
  null
  
)

export default component.exports